import {Group, Stack, Text, useMantineTheme} from "@mantine/core";

interface Props {
    startingValue: number,
    deviationPercentage: number,
    ticks: number,
    formatter?: (num:number) => string
}

export function SegmentedDeviation(
    {
        startingValue,
        deviationPercentage,
        ticks,
        formatter
    }: Props) {
    const theme = useMantineTheme()

    function getFloorCeiling() {
        if (startingValue) {
            const deviation = startingValue * deviationPercentage
            return {
                floor: startingValue - deviation,
                ceiling: startingValue + deviation,
            }
        } else {
            return {
                floor: 0,
                ceiling: 0,
            }
        }
    }

    function getTickValue() {
        const {floor, ceiling} = getFloorCeiling()
        const total = ceiling - floor
        return total / ticks
    }

    function renderTicks() {
        const renderedTicks = []
        const {floor} = getFloorCeiling()
        for (let i = 0; i < ticks; i++) {
            const curNumber = floor + (i * getTickValue())
            let color = theme.colors.gray[3]
            if (curNumber === startingValue) {
                color = "blue"
            } else if (curNumber < startingValue) {
                color = theme.colors.blue[5]
            }
            renderedTicks.push(
                <Group sx={{
                    height: 20,
                    borderRadius: 3,
                    flexGrow:1,
                    backgroundColor: color,
                }} key={i}>
                </Group>
            )
        }
        return renderedTicks
    }

    return (
        <Stack spacing={6}>
            <Group spacing={3} position="apart" w="100%">
                {renderTicks()}
            </Group>
            <Group position="apart">
                <Text size="sm">{formatter ? formatter(getFloorCeiling().floor) : getFloorCeiling().floor}</Text>
                <Text size="sm">{formatter ? formatter(getFloorCeiling().ceiling) : getFloorCeiling().ceiling}</Text>
            </Group>
        </Stack>
    )
}